<template>
  <div
    class="flex flex-col justify-center items-center fixed z-50 inset-0 bg-opacity-25 bg-black"
    @click.self="close"
  >
    <div class="form-card">
      <h3 class="font-display font-semibold text-lg text-content-700">
        Registrar ajuste de monedero
      </h3>
      <p class="text-sm text-content-400 mt-1">
        Saldo actual: {{ integerToCurrency(balance) }}
      </p>

      <div class="flex flex-col gap-4 mt-4">
        <div class="form-field">
          <label for="wallet_adjust_amount">Monto (negativo para descontar)</label>
          <input
            id="wallet_adjust_amount"
            type="number"
            step="0.01"
            v-model.number="form.amount"
            placeholder="Ej. 100 o -50"
          />
          <p v-if="isNegative" class="text-xs text-tertiary-600 mt-1">
            Se descontará del saldo disponible (no puede exceder
            {{ integerToCurrency(balance) }}).
          </p>
        </div>

        <div class="form-field">
          <label for="wallet_adjust_reason">Motivo (obligatorio)</label>
          <textarea
            id="wallet_adjust_reason"
            rows="2"
            v-model="form.reason"
            placeholder="Ej. compensación por reembolso, corrección..."
          ></textarea>
        </div>
      </div>

      <primary-button
        class="w-auto mt-6"
        :loading="loading"
        :disabled="!canConfirm"
        @buttonClicked="confirm"
        >Confirmar
      </primary-button>

      <button
        v-if="!loading"
        class="link mt-4 mx-auto w-full"
        @click.prevent="close"
      >
        Cancelar
      </button>
    </div>
  </div>
</template>

<script>
import { integerToCurrency } from "@/utils/currencyFormatter";

export default {
  name: "WalletAdjustModal",

  props: {
    balance: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      form: {
        amount: null,
        reason: "",
      },
    };
  },

  computed: {
    isNegative() {
      return Number(this.form.amount) < 0;
    },

    canConfirm() {
      const amount = Number(this.form.amount);
      return (
        Number.isFinite(amount) &&
        amount !== 0 &&
        this.form.reason.trim().length > 0 &&
        !this.loading
      );
    },
  },

  methods: {
    integerToCurrency,

    close() {
      if (this.loading) return;
      this.$emit("close");
    },

    confirm() {
      if (!this.canConfirm) return;

      this.$emit("confirm", {
        amount: Number(this.form.amount),
        reason: this.form.reason.trim(),
      });
    },
  },
};
</script>
